<template>
  <div
    class="page-content-main"
    :class="{
      'pa-0': noPadding,
      'pb-0': noBottomPadding,
      [`page-content-main--${size}`]: size,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
export type PageContentMainSize = '' | 'xSmall' | 'small' | 'size1000' | 'medium'

defineProps<{
  size?: PageContentMainSize
  noPadding?: boolean
  noBottomPadding?: boolean
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

$padding: 32px;

@mixin rootBlockWidth($width) {
  max-width: $width;
}

.page-content-main {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  padding: 24px $padding 20px;
  margin: 0 auto;

  @include media-md-max {
    padding: $pageContentMobilePadding;
    margin: 0;

    body:not(.platform-ios) & {
      box-sizing: border-box;
      width: 100%;
    }
  }

  @include media-sm-x-max {
    padding: 16px;
  }

  &--xSmall {
    @include rootBlockWidth(664px);
  }

  &--small {
    @include rootBlockWidth(996px);
  }

  &--size1000 {
    @include rootBlockWidth(1064px);
  }

  &--medium {
    @include rootBlockWidth(1128px);
  }
}
</style>
